import React, { useRef,useState } from 'react';
import { Button, Row, Col, Table, Label } from 'reactstrap';
import { SearchAsync } from '../../../../components/elements/SearchAsync';
import Select from 'react-select';
import '../../../micro/cotizacion/SyleQuoterMic/styleSearchMovilQuoterMic.css'

export const SearchQuoterMovil = (props) => {

    const {
     
        checkTypeClient, tooglePatient, formQuoterMic, handleChangePatient, 
        listCompanies, handleChangeCompany, handleChangeAgreement, listAgreement,
        informationPatient, informationCompany
    } = props;
    


    return (
        <>
        {/* SELECTORES */}
        <div className="mobile-company-selects">

            {checkTypeClient === 1 && (

                <div className="patient-search-wrapper">

                    <span
                        className="patient-create-btn"
                        onClick={tooglePatient}
                    >
                        <i className="fa fa-user-plus"></i>
                    </span>

                    <div className="patient-search-container">

                        <SearchAsync
                            cacheOptions={false}
                            value={formQuoterMic.id_patient}
                            name="id_patient"
                            method={handleChangePatient}
                            loincState={formQuoterMic.searchPatientState}
                            url="Patient/SearchPatient"
                            maxLenght={3}
                            placeholder="Selecciona un paciente"
                            mDisabled={formQuoterMic.id_quatation > 0}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />

                    </div>

                </div>

            )}

            {checkTypeClient === 3 && (

                <div className="mobile-company-selects">

                    <Select
                        isDisabled={formQuoterMic.id_quatation > 0}
                        classNamePrefix="company-select"
                        placeholder="Selecciona una empresa"
                        options={listCompanies}
                        value={
                            listCompanies.find(
                                x => x.value === formQuoterMic.id_company
                            ) || null
                        }
                        onChange={handleChangeCompany}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />

                    <Select
                        isDisabled={
                            !formQuoterMic.id_company ||
                            formQuoterMic.id_quatation > 0
                        }
                        classNamePrefix="company-select"
                        placeholder="Selecciona un convenio"
                        options={listAgreement}
                        value={formQuoterMic.id_agreement}
                        onChange={handleChangeAgreement}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />

                </div>

            )}

        </div>

        {/* INFORMACIÓN */}
        {checkTypeClient === 3 && informationCompany?.length > 0 && (

            <div className="mobile-company-info">

                <div className="mobile-info-item">
                    <i className="fa fa-phone" />
                    <div>
                        <span>Teléfono</span>
                        <strong>{informationCompany[0]?.phone}</strong>
                    </div>
                </div>

                <div className="mobile-info-item">
                    <i className="fa fa-file-text-o" />
                    <div>
                        <span>Factura</span>
                        <strong>{informationCompany[0]?.require_invoice}</strong>
                    </div>
                </div>

                <div className="mobile-info-item">
                    <i className="fa fa-credit-card" />
                    <div>
                        <span>Pago</span>
                        <strong>{informationCompany[0]?.payment}</strong>
                    </div>
                </div>

                <div className="mobile-info-item mobile-email">
                    <i className="fa fa-envelope" />
                    <div>
                        <span>Correo</span>
                        <strong>{informationCompany[0]?.contact_email}</strong>
                    </div>
                </div>

            </div>

        )}

        {checkTypeClient === 1 && informationPatient?.name && (
            <div className="mobile-patient-info">
                <br />
                <Row className="g-2">

                    <Col xs="6">
                        <div className="mobile-info-item">
                            <i className="fa fa-calendar" />
                            <div>
                                <span>Fecha Nac.</span>
                                <strong>{informationPatient.birthday ?? "----"}</strong>
                            </div>
                        </div>
                    </Col>

                    <Col xs="6">
                        <div className="mobile-info-item">
                            <i className="fa fa-phone" />
                            <div>
                                <span>Teléfono</span>
                                <strong>{informationPatient.phone ?? "----"}</strong>
                            </div>
                        </div>
                    </Col>

                    <Col xs="12" className='mt-2'>
                        <div className="mobile-info-item">
                            <i className="fa fa-envelope" />
                            <div>
                                <span>Correo</span>
                                <strong>{informationPatient.email ?? "----"}</strong>
                            </div>
                        </div>
                    </Col>

                </Row>

            </div>

        )}

        </>

    )
}
